import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Docente de Metodología | Lima, Perú',
  text: 'El material sobre tipos y diseños de investigación le cambió la cara a mis alumnos. Por fin entienden las diferencias sin confundirse. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor universitario | Montevideo, Uruguay',
  text: 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen desde cero bajo presión. Salgo de cada trimestre con la satisfacción de tener todo resuelto.'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  role: 'Docente de investigación | Caracas, Venezuela',
  text: 'El mapa visual del proceso de investigación transformó el grupo más difícil que tenía. Lo proyecto al inicio de cada clase y mis alumnos saben exactamente en qué parte del proceso están. Eso no lo encontré en ningún otro material.'
}, {
  initials: 'AM',
  name: 'Ana M.',
  role: 'Docente universitaria | Buenos Aires, Argentina',
  text: 'El glosario me devolvió el tiempo de clase. Antes perdía los primeros veinte minutos explicando términos. Ahora mis alumnos llegan con el glosario leído y podemos ir directo al contenido.'
}, {
  initials: 'SR',
  name: 'Sebastián R.',
  role: 'Profesor de metodología | Quito, Ecuador',
  text: 'El manual de preguntas difíciles fue una revelación. Mis alumnos hacen preguntas complejas y ahora tengo siempre la respuesta correcta. Eso cambió completamente mi seguridad en el aula.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-64" data-mp="2baf74ru224sk">
      <div className="max-w-6xl mx-auto" data-id="element-65" data-mp="2b82hrtlyws5h">
        <div className="text-center mb-16" data-id="element-66" data-mp="26aj00jq29x8s">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-67" data-mp="269r7xivoahn9">
            Lo que dicen los docentes que ya tienen su Mega Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68" data-mp="2crki9vqovh5y">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69" data-mp="1yqi03u2ter0b" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-70" data-mp="1k0kgzsjqsrhz" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71" data-mp="1b1paefcsdfe5">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" data-mp="rfncqwm7q8pv" data-mpi={j} />)}
              </div>

              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-73" data-mp="mhlu2csp8bex">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74" data-mp="11f4krkoxsyp0">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-75" data-mp="weqikja0oiyw">
                  {t.initials}
                </div>
                <div data-id="element-76" data-mp="15g7vjss4o4jd">
                  <div className="font-bold text-white" data-id="element-77" data-mp="15gpz7ah4dl1b">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-78" data-mp="1k4ujujzqg6mq">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}